<template>
  <v-card-title class="mx-2 px-1">
    <template>
      <div class="pt-3" style="width:100%;">
        <div class="line_temp__ttl">
          <span class="lineTitleClamp">{{title}}</span>
        </div>
        <div class="line_temp__desc">
          <v-textarea
          readonly
          v-model="description"
          auto-grow
          solo
          hide-details
          row-height="1"
          placeholder="説明を入力してください。"
          class="lineTempDesc"
          >
          </v-textarea>
        </div>
      </div>
    </template>
  </v-card-title>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'

export default {
  name: 'templateText',
  props: {
    title: {
      type: String
    },
    description: {
      type: String
    }
  },
  data () {
    return {
    }
  },
  destroyed () {
  },
  mounted () {
    this.initText()
  },
  computed: {
    ...mapGetters([
    ])
  },
  watch: {
  },
  methods: {
    ...mapMutations([
    ])
  }
}
</script>

<style scoped>
.line_temp__ttl {
  font-weight: bold;
  font-size: 21px;
  padding-left: 5px;
}
.lineTempDesc{
  font-size: 13.5px;
}
</style>



// WEBPACK FOOTER //
// src/components/webchat/message/fragments/line/item/templateText.vue